import {NgModule, Component, Input, HostBinding, ViewEncapsulation, ChangeDetectionStrategy, SimpleChanges, ElementRef} from '@angular/core';

@Component({
    selector: 'tab',
    template:`        
        <ng-content></ng-content>
    `,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush          
})
export class Tab {
    @Input() title:string;
    @Input() isActive:boolean = false
    @Input() enabled:boolean = true

    public nativeElement:any;

    constructor(protected elem:ElementRef) {
        this.nativeElement = elem.nativeElement;
    }

    ngOnInit(){
    }
}




// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/tabs/tab.component.ts